import * as $ from "jquery";
(($: any) => {
    const csvGenerationForm = $(".csv-generation-container form");
    if (csvGenerationForm.length === 0) {
        return;
    }
    const csvSubmitButton = csvGenerationForm.find(".csv-generation-button");
    const firstDatepicker = csvGenerationForm.find(".elo-datepicker.first");
    const secondDatepicker = csvGenerationForm.find(".elo-datepicker.second");
    if (csvSubmitButton.length === 0 ||
        firstDatepicker.length === 0 ||
        secondDatepicker.length === 0) {
        return;
    }
    csvSubmitButton.click((e: Event) => {
        const formattedStartDate = getFormattedDate(firstDatepicker[0] && firstDatepicker[0].value);
        const formattedEndDate = getFormattedDate(secondDatepicker[0] && secondDatepicker[0].value);
        if (formattedStartDate > formattedEndDate) {
            e.preventDefault();
            csvGenerationForm.addClass("invalid");
        }
    });

    [firstDatepicker, secondDatepicker].forEach((datepicker) => {
        $(datepicker).focus(() => {
            csvGenerationForm.removeClass("invalid");
        });
    });

    function getFormattedDate(stringDate: string): Date {
        const parts = stringDate.split(".").map((x) => parseInt(x, 10));
        return new Date(parts[2], parts[1], parts[0]);
    }
})($);
